module.exports = __webpack_public_path__ + "img/brightness_0.f71e1a1c.png";